import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { RouteSaveDto } from "../../models/route/route";
import { RouteDialog } from "./RouteDialog";

export const RouteDialogWrapper = () => {
    const history = useHistory();
    const [route, setRoute] = useState<RouteSaveDto>();

    useEffect(() => {
        setRoute({
            id: null,
            rowId: null,
            name: "",
            comment: null,
            isActive: true,
        });
    }, []);

    return <RouteDialog open item={route} onClose={() => history.goBack()} enableIsActive />;
};
